import { useAppDispatch, useAppSelector } from '../../../utils/redux';
import {
    changeCustomerValue,
    CheckoutCustomerFormValues,
    getCustomerError,
    getCustomerValue,
    isCheckoutFieldRequired,
    touchField,
} from '../slices';

import { createCheckoutFormFieldDataTestId } from './createCheckoutFormFieldDataTestId';

export const useCheckoutField = <K extends keyof CheckoutCustomerFormValues>(name: K) => {
    const dispatch = useAppDispatch();
    const required = useAppSelector((state) => isCheckoutFieldRequired(state, { name }));
    const customerValue = useAppSelector((state) => getCustomerValue(state, { name }));
    const error = useAppSelector((state) => getCustomerError(state, { name }));
    const dataTestId = createCheckoutFormFieldDataTestId(name);

    const onChange = (value: string | number) => {
        dispatch(changeCustomerValue({ key: name, value }));
    };

    const onBlur = () => {
        dispatch(touchField(name));
    };

    return {
        onBlur,
        onChange,
        error,
        customerValue,
        required,
        dataTestId,
    };
};
